import { RecentArticle } from '../types/Article';

/**
 * Updates the recently viewed pages in localStorage and adds them to the combined recents list
 * @param article The article to add to recently viewed pages
 */
export const updateRecentlyViewedPages = (article: RecentArticle): void => {
  try {
    // Get existing recents
    const storedRecentArticles = JSON.parse(
      localStorage.getItem('recentArticles') || '[]'
    );

    // Check if article is already in the list
    const existingIndex = storedRecentArticles.findIndex(
      (a: RecentArticle) => a.articleId === article.articleId
    );

    let updatedArticles;
    if (existingIndex !== -1) {
      // If article exists, move it to the top and update timestamp
      updatedArticles = [
        { ...article, timestamp: Date.now() },
        ...storedRecentArticles.filter(
          (_: RecentArticle, index: number) => index !== existingIndex
        ),
      ];
    } else {
      // If article doesn't exist, add it to the top
      updatedArticles = [
        { ...article, timestamp: Date.now() },
        ...storedRecentArticles,
      ];
    }

    // Keep only the 5 most recent articles
    if (updatedArticles.length > 5) {
      updatedArticles.splice(5);
    }

    // Save to localStorage
    localStorage.setItem('recentArticles', JSON.stringify(updatedArticles));

    // Clear the separate recently viewed pages storage since we're using a combined list
    localStorage.setItem('recentlyViewedPages', JSON.stringify([]));
  } catch (error) {
    console.error('Error updating recently viewed pages:', error);
  }
};

/**
 * Gets the recently viewed pages from localStorage
 * @returns Array of recently viewed articles
 */
export const getRecentlyViewedPages = (): RecentArticle[] => {
  try {
    // Since we're using a combined list, we'll return the recents from the main storage
    const recents = JSON.parse(localStorage.getItem('recentArticles') || '[]');
    return recents;
  } catch (error) {
    console.error('Error getting recently viewed pages:', error);
    return [];
  }
};
